// Documento: Etiquetas
// Categoría: General
// Última actualización: 2024-12-28

const document = {
  "id": "etiquetas-segmentacion",
  "title": "Etiquetas",
  "category": "General",
  "description": "Las etiquetas son funciones útiles e importantes para segmentar y dirigir campañas de marketing a tus suscriptores de Messenger. Aprende a crear, configurar y usar etiquetas para organizar tu audiencia.",
  "explanations": [
    {
      "title": "¿Qué son las etiquetas y para qué sirven?",
      "content": "Las etiquetas son funciones útiles e importantes para segmentar y dirigir campañas de marketing a tus suscriptores de Messenger. Puedes usar las etiquetas para agrupar tu audiencia según diferentes criterios como:\n\n• Diferentes campañas\n• Diferentes productos o servicios\n• Diferentes segmentaciones\n• Y muchas más cosas"
    },
    {
      "title": "¿Dónde crear etiquetas?",
      "content": "Puedes crear etiquetas en la sección de Flujos. Ve a Menú > Flujos > Etiquetas para crear una nueva etiqueta y asignarle un nombre."
    },
    {
      "title": "Sincronización con Facebook",
      "content": "También puedes habilitar la sincronización de etiquetas para integrar las etiquetas que asignas a tus suscriptores con la Bandeja de entrada del Administrador de páginas de Facebook. De esta manera, las etiquetas en Runamatic se sincronizarán y reflejarán en tu Bandeja de entrada del Administrador de páginas de Facebook.\n\n**IMPORTANTE:** No podrás sincronizar etiquetas hasta que hayas aceptado los Términos de servicio de contactos de página. Visita https://business.facebook.com/latest/inbox/all/ para revisar y aceptar."
    },
    {
      "title": "Métodos para agregar etiquetas",
      "content": "Una vez que sepas cómo crear una etiqueta, veremos cómo agregar etiquetas a tus suscriptores para segmentar la audiencia. Agregar etiquetas a los suscriptores se puede hacer de dos maneras:\n\n• **Manualmente:** Proceso que requiere intervención manual\n• **Automáticamente:** A través de flujos automatizados"
    }
  ],
  "steps": [
    {
      "title": "Crear una nueva etiqueta",
      "content": "Ve a Menú > Flujos > Etiquetas. Haz clic en crear una nueva etiqueta y asígnale un nombre descriptivo que te ayude a identificar el segmento de audiencia."
    },
    {
      "title": "Habilitar sincronización (opcional)",
      "content": "Si deseas que las etiquetas se sincronicen con Facebook, habilita la opción de sincronizar etiquetas en la configuración. Esto te permitirá ver las etiquetas también en la Bandeja de entrada del Administrador de páginas de Facebook."
    },
    {
      "title": "Agregar etiqueta a suscriptor individual (método manual)",
      "content": "Para aplicar una etiqueta a un suscriptor particular:\n- Ve a la pestaña \"Contactos\" navegando a través del menú principal\n- Selecciona el suscriptor haciendo clic en el nombre de la lista\n- Agrega la etiqueta en el campo correspondiente según sea necesario"
    },
    {
      "title": "Agregar etiquetas a múltiples suscriptores (método manual)",
      "content": "También puedes agregar etiquetas a múltiples suscriptores manualmente:\n- Selecciona \"Contactos\" y usa las casillas de verificación para seleccionar múltiples contactos\n- Haz clic en las \"tres líneas horizontales\"\n- Selecciona \"Agregar Etiqueta\" para agregar etiquetas a los múltiples suscriptores seleccionados"
    },
    {
      "title": "Configurar etiquetado automático en flujos - Usando Acciones",
      "content": "Para automatizar el etiquetado en tus flujos:\n- Crea primero una etiqueta\n- Selecciona el flujo en el que deseas agregar la función de etiquetado automático\n- Haz clic en + o doble clic en el lienzo > acción (para elegir el bloque de acción)\n- Haz clic en el bloque de acción > agregar contenido > acciones > agregar etiqueta\n- Configura la etiqueta que se asignará automáticamente cuando los usuarios lleguen a ese punto del flujo"
    },
    {
      "title": "Configurar etiquetado automático - Usando Botones",
      "content": "Tanto los botones como los botones de respuesta rápida pueden usarse para asignar etiquetas a los suscriptores:\n- Al crear botones en tu flujo, configura la etiqueta que se asignará\n- Cuando el usuario haga clic en el botón en el flujo de chat, la etiqueta integrada con el botón se asignará automáticamente a ese suscriptor\n- Esto permite un etiquetado dinámico basado en las acciones e intereses del usuario"
    }
  ],
  "tags": [
    "etiquetas",
    "segmentación",
    "marketing",
    "audiencia",
    "campañas",
    "flujos",
    "automatización",
    "facebook",
    "contactos"
  ],
  "lastUpdated": "2024-12-28",
  "difficulty": "básico"
};

export default document;
